import './App.css'
import "@aws-amplify/ui-react/styles.css";
import BookkeeproLogo from './images/bookkeepro_logo.png'
import { Button, Heading, Image, Text, View, useAuthenticator, useTheme } from "@aws-amplify/ui-react";
import AllUploadedFiles from "./components/AllUploadedFiles";
import { useState } from 'react';
import { PiDotsThreeOutlineVerticalFill } from 'react-icons/pi'
import { FaPowerOff } from 'react-icons/fa6'
import { MdLogout } from 'react-icons/md'
import { useRef } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

function App() {

  const [threedot_clickek, setThreedot_clicked] = useState(false)
  const windowref = useRef(null)

  function decideOpenNavInfo() {
    threedot_clickek === true ? setThreedot_clicked(false) : setThreedot_clicked(true)
  }

  // to close navbar__info if it is open and user clicked outside of navbar__info window
  function handleClickOutside(event) {
    if (windowref.current && !windowref.current.contains(event.target)) {
      setThreedot_clicked(false);
    }
  }

  function contactUsButtonHandler() {
    window.open('mailto:satyam.gire@sundeus.com', '_self');
  }

  const components = {
    Header() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            width={'15rem'}
            alt="Bookkeepro"
            src={BookkeeproLogo}
          />
        </View>
      );
    },

    Footer() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.medium}>
          <Text color={tokens.colors.neutral[80]}>
            &copy; All Rights Reserved
          </Text>
        </View>
      );
    },

    SignIn: {
      Header() {
        const { tokens } = useTheme();

        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={4}
          >
            Sign in to your account
          </Heading>
        );
      },
      Footer() {
        const { toResetPassword } = useAuthenticator();

        return (<>
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              Forget Password
            </Button>
          </View>
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={()=> contactUsButtonHandler()}
              size="small"
              variation="link"
            >
              Contact Us
            </Button>
          </View>
        </>
        );
      },
    },

    SignUp: {
      Header() {
        const { tokens } = useTheme();

        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={4}
          >
            Create a new account
          </Heading>
        );
      },
      Footer() {
        const { toSignIn } = useAuthenticator();

        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              Back to Sign In
            </Button>
          </View>
        );
      },
    },
    ConfirmSignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
    SetupTOTP: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
    ConfirmSignIn: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
    ResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
    ConfirmResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
  };

  const formFields = {
    signIn: {
      username: {
        placeholder: 'Enter your email',
      },
    },
    signUp: {
      password: {
        label: 'Password:',
        placeholder: 'Enter your Password:',
        isRequired: false,
        order: 2,
      },
      confirm_password: {
        label: 'Confirm Password:',
        order: 1,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: 'Enter your Password:',
      },
    },
    resetPassword: {
      username: {
        placeholder: 'Enter your email:',
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Enter your Confirmation Code:',
        label: 'New Label',
        isRequired: false,
      },
      confirm_password: {
        placeholder: 'Enter your Password Please:',
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
  };

  return (
    <>
      <style>
        {`
          .amplify-tabs-item {
            display: none;
          }
        `}
      </style>
      <Authenticator formFields={formFields} components={components} >
        {({ user, signOut }) => (
          <div onClick={(event) => { handleClickOutside(event) }} className='container'>
            <div className="navbar">
              <img src={BookkeeproLogo} alt="Logo" />
              <button id='log_out_navbar_button' onClick={signOut}><MdLogout id='poweroff_icon'/><p>Logout</p></button>
            </div>
            <AllUploadedFiles /*bucketname={JSON.parse(user.attributes.profile).bucketname}*/></AllUploadedFiles>
          </div>
        )}
      </Authenticator>
    </>

  );
}

export default App;
